(() => {
  const enhance = (root) => {
    root.querySelectorAll('.quantity-unit .per-unit, .price .custom-quantity-unit').forEach(unit => {
      if (unit.querySelector('[data-spoken-unit]')) return;
      const notation = unit.textContent.trim();
      const words = notation.replace(/^\s*\/\s*/, 'per ').replace(/sq\.?\s*ft\.?/gi, 'square foot');
      const visual = document.createElement('span');
      visual.setAttribute('aria-hidden', 'true');
      visual.textContent = notation;
      const spoken = document.createElement('span');
      spoken.className = 'visually-hidden';
      spoken.dataset.spokenUnit = '';
      spoken.textContent = ' ' + words;
      unit.replaceChildren(visual, spoken);
    });
  };
  enhance(document);
  new MutationObserver(records => {
    records.forEach(record => {
      if (record.target instanceof Element && record.target.matches('.per-unit, .custom-quantity-unit')) enhance(record.target.parentElement);
      record.addedNodes.forEach(node => { if (node instanceof Element) enhance(node.parentElement || node); });
    });
  }).observe(document.body, { childList: true, subtree: true });
})();
